import styled from 'styled-components';

const IconContainer = styled.span`
  display: flex;
  align-items: center;
  width: ${({ iconSize }) => iconSize || '12px'};
  height: ${({ iconSize }) => iconSize || '12px'};
  > svg {
    width: 100%;
    height: 100%;
  }
`;

export default IconContainer;
